import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFlyoutDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetFlyoutDrawerIsOpen";
import setNavDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetNavDrawerIsOpen";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import ChevronRight, { chevronRightString } from "@insite/mobius/Icons/ChevronRight";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import uniqueId from "lodash/uniqueId";
import React from "react";
import { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    isFlyOutOpen: state.components.addressDrawer.isOpen,
    isNavDrawerOpen: state.components.addressDrawer.navDrawerIsOpen,
});
const mapDispatchToProps = {
    setNavDrawerIsOpen
};

interface OwnProps {
    title?: string;
    links?: any;
}

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;


export interface SurAccordionStyles {
    resourceContainer?: InjectableCss;
    resourceTitleIcon?: InjectableCss;
    resourceIcon?: IconPresentationProps;
    resourceRoatedIcon?: IconPresentationProps;
    resourceTitle?: InjectableCss;
    resourceLinkContainer?: InjectableCss;
    resourceLink?: LinkPresentationProps;
}

export const accordionStyle: SurAccordionStyles = {
    resourceContainer: {
        css: css`
            cursor: pointer;
        `,
    },
    resourceTitleIcon: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
        `,
    },
    resourceIcon: {
        css: css`
            svg {
                width: 15px;
                height: 15px;
            }
        `,
    },
    resourceRoatedIcon: {
        css: css`
            svg {
                transform: rotate(90deg);
                width: 15px;
                height: 15px;
            }
        `,
    },
    resourceTitle: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.bold};
            font-size: ${TYPOGRAPHY.size.small};
            line-height: ${TYPOGRAPHY.lineHeight.xbase};
            color: ${getColor("text.main")};
        `,
    },
    resourceLinkContainer: {
        css: css`
            &:first-child {
                padding: 10px 10px 0px 10px;
            }
            padding: 2px 10px 0px 10px;
        `,
    },
};

const styles = accordionStyle;

const SurAccordion: FC<Props> = ({ title, links, isFlyOutOpen, isNavDrawerOpen, setNavDrawerIsOpen }) => {
    const [isOpen, setIsOpen] = useState(false);
    const closeDrawer = () => {
        if (isNavDrawerOpen) {
            setNavDrawerIsOpen({ navDrawerIsOpen: false });
            setTimeout(() => setNavDrawerIsOpen({ navDrawerIsOpen: undefined }), 300);
        }
    };

    return (
        <StyledWrapper {...styles.resourceContainer} onClick={() => setIsOpen(!isOpen)}>
            <StyledWrapper {...styles.resourceTitleIcon}>
                <Typography {...styles.resourceTitle}>{title}</Typography>
                <Icon
                    {...(isOpen ? { ...styles.resourceRoatedIcon } : { ...styles.resourceIcon })}
                    src={ChevronRight}
                />
            </StyledWrapper>
            {isOpen && (
                <StyledWrapper>
                    {links.map((link: { url: string | undefined; title: string }) => {
                        return (
                            <StyledWrapper key={uniqueId()} {...styles.resourceLinkContainer} onClick={closeDrawer}>
                                <Link href={link.url} {...styles.resourceLink} >
                                    {link.title}
                                </Link>
                            </StyledWrapper>
                        );
                    })}
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(SurAccordion);
